import { createRoot } from 'react-dom/client'
import type { RouterProviderProps } from 'react-router-dom'
import { RouterProvider } from 'react-router-dom'

import { Provider } from '@app/components/ui/provider'
import { Toaster } from '@app/components/ui/toaster'
import router from '@app/router'
import '@fontsource-variable/inter'

const container = document.getElementById('react-root')
container.style.height = '100%'

const root = createRoot(container)

root.render(
  <Provider>
    <RouterProvider router={router as unknown as RouterProviderProps['router']} />
    <Toaster />
  </Provider>
)
